import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Home } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Splash({ onDone }) {
  const { t } = useLang();
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => { setShow(false); onDone && onDone(); }, 2600);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 0.98 }}
          transition={{ duration: 0.7 }}
          className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden"
          data-testid="splash-screen"
          style={{ backgroundColor: "#064e3b" }}
        >
          <div className="absolute inset-0 opacity-25" style={{ backgroundImage: `url(${BG})`, backgroundSize: "cover", backgroundPosition: "center" }} />
          <div className="absolute inset-0 bg-brand-emerald/70" />
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative z-10 text-center px-6"
          >
            <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-6 backdrop-blur">
              <Home className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-heading font-extrabold text-white text-4xl sm:text-6xl tracking-tight">
              {t("tagline")}
            </h1>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 2.4, ease: "linear" }}
              className="h-0.5 bg-brand-terracotta mt-8 mx-auto max-w-xs origin-left"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
